var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBriefcase(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 5c0-1.66 1.34-3 3-3h4c1.65 0 3 1.34 3 3v1c0 .55-.45 1-1 1H8c-.56 0-1-.45-1-1V5Zm3-1c-.56 0-1 .44-1 1h6c0-.56-.45-1-1-1h-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 8c0-1.66 1.34-3 3-3h16c1.65 0 3 1.34 3 3v11c0 1.65-1.35 3-3 3H4c-1.66 0-3-1.35-3-3V8Zm3-1c-.56 0-1 .44-1 1v11c0 .55.44 1 1 1h16c.55 0 1-.45 1-1V8c0-.56-.45-1-1-1H4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 8c0-1.66 1.34-3 3-3h16c1.65 0 3 1.34 3 3v3c0 .44-.29.83-.72.95l-10 3c-.19.05-.39.05-.58 0l-10-3c-.43-.13-.72-.52-.72-.96v-3Zm3-1c-.56 0-1 .44-1 1v2.25l9 2.7 9-2.7V7.99c0-.56-.45-1-1-1H4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 16v-4h2v4h-2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.e977d0292525e93218384d230dd207ec.svg";
export { ForwardRef as ReactComponent };